/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IUserInfo } from '../../api/domain';

enum UserInfoApiActions {
    FETCH_USER_INFO = 'user-info-api.fetch.user-info',
    FETCH_USER_INFO_SUCCESS = 'user-info-api.fetch.user-info-success',
    FETCH_USER_INFO_FAILURE = 'user-info-api.fetch.user-info-failure',
}

export const fetchUserInfo = createAction(UserInfoApiActions.FETCH_USER_INFO);
export const fetchUserInfoSuccess = createAction<IUserInfo>(UserInfoApiActions.FETCH_USER_INFO_SUCCESS);
export const fetchUserInfoFailure = createAction(UserInfoApiActions.FETCH_USER_INFO_FAILURE);
